export default __webpack_public_path__ + "static/media/cuv.84025455.svg";